import React from "react";
import logo_white from "../../assets/images/header/mainLogo.png";
import logo_header from "../../assets/images/header/logoHeader.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer>
        <div className="top_footer" id="contact">
          <div className="blure_shape bs_1"> </div>
          <div className="blure_shape bs_2"> </div>

          <div className="container">
            <div className="row">
              <div className="col-lg-5 col-md-6 col-12">
                <div className="abt_side">
                  <div className="logo logo-container">
                    <img src={logo_white} alt="Logo Woven Mina" className="header-logo-top" />
                    <img src={logo_header} alt="Logo Woven Mina" className="header-logo-bottom" />
                  </div>
                  <p>
                    Mina Label merupakan sebuah perusahaan yang bergerak di
                    bidang jasa manufacturing branding garment, yang menyediakan
                    jasa manufacturing label woven, hangtag dan printing. Kami
                    berlokasi di Jakarta, Indonesia.
                  </p>
                  <ul className="app_btn"></ul>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-12">
                <div className="links">
                  <h5>Quick Links</h5>
                  <ul>
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <Link to="/logo">Galeri Logo</Link>
                    </li>
                    <li>
                      <Link to="/jasa">Jasa</Link>
                    </li>
                    <li>
                      <Link to="/contact">Kontak Kami</Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-12">
                <h5>Lokasi Kita</h5>
                <div className="news_letter">
                  <p style={{ fontWeight: "bold" }}>Factory/Marketing Office</p>
                  <p>
                    Jl. Jembatan Besi 6 No. 7 RT/RW 01/03 Kecamatan Tambora,
                    Jakarta Barat
                  </p>
                  <p style={{ fontWeight: "bold" }}>Store 1</p>
                  <p>
                    Tanah Abang Blok Auri Ruko CC3 Mina Label Jakarta Pusat
                    (Disamping Bank BPR)
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bottom_footer">
            <div className="container">
              <div className="row">
                <div className="col-md-4">
                  <p>© Copyrights 2025 Mina Label</p>
                </div>
                {/* <div className="col-md-4">
                  <ul className="social_media">
                    <li>
                      <Link
                        to="https://themeforest.net/user/kalanidhithemes/portfolio"
                        aria-label="facebook page"
                      >
                        <i className="icofont-facebook" />
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="https://www.behance.net/kalanidhithemes"
                        aria-label="twitter page"
                      >
                        <i className="icofont-twitter" />
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="https://themeforest.net/user/kalanidhithemes/portfolio"
                        aria-label="instagram page"
                      >
                        <i className="icofont-instagram" />
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="https://themeforest.net/user/kalanidhithemes/portfolio"
                        aria-label="pinterest page"
                      >
                        <i className="icofont-pinterest" />
                      </Link>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
export default Footer;
